module.exports = __webpack_public_path__ + "static/media/tablet_background.1d960790.jpg";